/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Labelrequired5Inputs */

const en_coinvestments_lpdealoverviewcontent_labelrequired5 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Labelrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label is required`)
};

/**
* | output |
* | --- |
* | "Label is required" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Labelrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_labelrequired5 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Labelrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Labelrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_labelrequired5(inputs)
});
export { coinvestments_lpdealoverviewcontent_labelrequired5 as "coInvestments_lpDealOverviewContent_labelRequired" }